import type { ComponentProps } from 'react';
import { Badge } from '@/components/ui/badge';
import type { ContractStatus } from './contract-state';

const STATUS_CONFIG: Record<
  ContractStatus,
  { label: string; variant: ComponentProps<typeof Badge>['variant'] }
> = {
  sending: { label: 'Enviando', variant: 'info-subtle' },
  not_sent: { label: 'Aguardando envio', variant: 'secondary-subtle' },
  waiting: { label: 'Aguardando assinatura', variant: 'info-subtle' },
  signed: { label: 'Assinado', variant: 'success-subtle' },
  error: { label: 'Indisponível', variant: 'destructive-subtle' },
};

interface ContractStatusBadgeProps {
  status: ContractStatus;
}

export function ContractStatusBadge({ status }: ContractStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
